<div class="container">
  <div class="form-signin">
    @if (!token) {
    <div>
      <h2 class="form-signin-heading">Forgot Password</h2>
      <span class="form-text sub-title">Enter your email address and we’ll send a like to reset your password</span>
    </div>
    }
    @if (token) {
    <div>
      <h2 class="form-signin-heading">Change Password</h2>
      <span class="form-text sub-title">Enter your new password</span>
    </div>
    }
    <div [hidden]="errors.length === 0">
      <p-messages [value]="errors" />
    </div>
    @if (!token) {
    <form (ngSubmit)="requestPass()" #requestPassForm="ngForm">
      <div class="mb-3">
        <label for="input-email" class="sr-only">Enter your email address</label>
        <input name="email" [(ngModel)]="user.email" id="input-email" #email="ngModel" class="form-control"
          placeholder="Email address" pattern=".+@.+..+" type="email"
          [class.form-control-danger]="email.invalid && email.touched" required autofocus />
        @if (email.invalid && email.touched && email.errors?.required) {
        <small class="form-text text-danger"> Email is required! </small>
        }
        @if (email.invalid && email.touched && email.errors?.pattern) {
        <small class="form-text text-danger"> Email should be the real one! </small>
        }
      </div>
      <button [disabled]="!requestPassForm.form.valid" class="btn btn-lg btn-primary btn-block">Request link</button>
    </form>
    }
    @if (token) {
    <form (ngSubmit)="changePass()" #changePassForm="ngForm">
      <div class="mb-3">
        <label for="newPassword" class="sr-only">New Password</label>
        <input type="password" class="form-control" [(ngModel)]="newPassword" placeholder="New password"
          #newPasswordCtrl="ngModel" name="newPasswordCtrl" id="newPasswordCtrl" minlength="settings.minPasswordLength"
          appPasswordValidator="newPasswordCtrl" />
        @if (!newPassword && newPasswordCtrl.touched) {
        <small class="form-text text-danger"> Password is required! </small>
        }
        @if (newPassword && newPasswordCtrl.touched && newPassword.length < settings.minPasswordLength) { <small
          class="form-text text-danger">
          Password length must be at least {{ settings.minPasswordLength }} characters<br />
          </small>
          }
          @if (newPassword && newPasswordCtrl.touched && newPasswordCtrl.errors?.invalidPassword) {
          <small class="form-text text-danger"> Password must have lowercase, uppercase, and special characters </small>
          }
      </div>
      <div>
        <label for="confirm-password" class="sr-only">New Password Again</label>
        <input type="password" class="form-control" [(ngModel)]="confirmPassword" placeholder="Confirmation password"
          name="confirm-password" #confirmPasswordCtrl="ngModel" id="confirm-password" />
        @if (newPassword && confirmPasswordCtrl.touched && newPassword !== confirmPassword) {
        <small class="form-text text-danger"> Password is not confirmed! </small>
        }
      </div>
      <button
        [disabled]="!(newPassword && confirmPassword && newPassword === confirmPassword && !newPasswordCtrl.errors?.invalidPassword)"
        class="btn btn-lg btn-primary btn-block">
        Change Password
      </button>
    </form>
    }

    <div>
      <small class="form-text">
        Already have an account?
        <a routerLink="../login">
          <strong>Sign In</strong>
        </a>
      </small>
    </div>
  </div>
</div>